/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["午夜", "早上", "上午", "中午", "下午", "晚上", "凌晨"], u, u], u, ["00:00", ["05:00", "08:00"], ["08:00", "12:00"], ["12:00", "13:00"], ["13:00", "19:00"], ["19:00", "24:00"], ["00:00", "05:00"]]];
